import { BrowserRouter as Router } from 'react-router'
import { I18nextProvider } from 'react-i18next'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider, Authenticated, Unauthenticated, AuthLoading } from '@agion/auth'
import type { AuthConfig } from '@agion/auth'
import { AppRouter } from './router/infra_router'
import i18n from './core/infra_i18n'
import { getConfig } from './core/infra_runtime_env'
import { Spinner } from '@agion/ui'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30000, // 30s default stale time
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

const authUrl =
  getConfig('VITE_AUTH_URL') ??
  getConfig('VITE_AUTH_SERVICE_URL') ??
  'http://localhost:8080'

const authConfig: AuthConfig = {
  authUrl,
  apiUrl: getConfig('VITE_API_URL', 'http://localhost:8090') ?? 'http://localhost:8090',
  loginUrl: getConfig('VITE_LOGIN_URL', 'http://localhost:3000') ?? 'http://localhost:3000',
  appName: 'control-ui',
  mockAuth: getConfig('VITE_MOCK_AUTH') === 'true',
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18n}>
        <AuthProvider config={authConfig}>
          <AuthLoading>
            <div className="flex h-screen items-center justify-center">
              <Spinner size="lg" />
            </div>
          </AuthLoading>
          <Authenticated>
            <Router>
              <AppRouter />
            </Router>
          </Authenticated>
          <Unauthenticated>
            <RedirectToLogin />
          </Unauthenticated>
        </AuthProvider>
      </I18nextProvider>
    </QueryClientProvider>
  )
}

function RedirectToLogin() {
  const loginUrl = getConfig('VITE_LOGIN_URL', 'http://localhost:3000') ?? 'http://localhost:3000'
  window.location.href = `${loginUrl}?app=control-ui&return_to=${encodeURIComponent(window.location.href)}`
  return null
}

export default App
